import React, { Fragment }  from "react";

import HCaptcha from '@hcaptcha/react-hcaptcha';

import CheckIn  from "~/services/checkIn";


const HCaptchaType = ({ setLoading, addCheckinTimeout, setMessage, setIsError, verifyCheckIn, setCheckinType, setOverlayType })=> {

  const handleVerificationSuccess = (token)=> {

    setLoading(true);
    CheckIn.bonus({ token }).then((response)=> {
      response.nextCheckin && addCheckinTimeout(response.nextCheckin);
      setMessage(response.message);
      setCheckinType('hcaptcha');
      setOverlayType('claimed');
      verifyCheckIn();
    }).catch((err)=> {
      setIsError(true);
      setMessage(err);
      setOverlayType('claimed');
    }).finally(()=> setLoading(false));
  };

  return (
    <Fragment>
      <h6 className="text-muted m-t-40 m-b-50 p-l-20 p-r-20">
        Get your check-in bonus by completing the captcha puzzle and you will earn 10 points, you can complete 4 puzzles a day.
      </h6>
      <div className="m-t-50">
        <HCaptcha sitekey={process.env.REACT_APP_HCAPTCHA_KEY} onVerify={handleVerificationSuccess} />
        <div className="text-muted text-center" style={{width:"100%", position: "absolute", bottom: "20px"}}>V:1000:1</div>
      </div>
    </Fragment>
  );
};


export default HCaptchaType;
